<div [ngClass]="customClass" [style.width]="width" class="cab-input">
  @if (label.length > 1) {
    <app-cab-label [for]="id" [label]="label" [required]="required" />
  }

  <div class="d-flex align-items-center position-relative">
    <ng-content select="#cab-input-before" />
    <input
      [dropSpecialCharacters]="dropSpecialCharacters"
      [formControl]="formControl"
      [mask]="mask"
      [step]="step"
      [patterns]="patterns"
      [type]="type"
      [allowNegativeNumbers]="allowNegativeNumbers"
      [thousandSeparator]="thousandSeparator"
      [id]="id"
      [max]="max"
      [min]="min"
      (input)="onInput.emit(formControl.value)"
      (focus)="handleFocus($event)"
      (blur)="handleBlur($event)"
      [placeholder]="placeholder | translate"
      [prefix]="prefix"
      [suffix]="suffix"
      [readonly]="readonly"
      [showMaskTyped]="showMaskTyped"
      [attr.autocomplete]="autocomplete"
      class="cab-input-field form-control form-control-{{ size }} w-100"
    />
    <ng-content select="#cab-input-after" />
    @if (type === "password" || eyeIconToggle()) {
      <span
        (click)="togglePasswordType()"
        class="input-icon flex items-center mt-7 py-5 bg-none clear-btn"
        [style]="
          !eyeIconToggle()
            ? inputTypePasswordStyleHide
            : inputTypePasswordStyleShow
        "
      >
        @if (eyeIconToggle()) {
          <app-keenicon name="eye" class="fs-2"></app-keenicon>
        } @else {
          <app-keenicon name="eye-slash" class="yum fs-2"></app-keenicon>
        }
      </span>
    }
    @if (isPending) {
      <div
        class="spinner-border spinner-border-sm text-secondary"
        style="position: absolute; right: 10px"
        role="status"
      ></div>
    }
  </div>

  @if (showValidationErrors()) {
    <div [innerHTML]="errorMessagesHtml()" class="text-danger text-start"></div>
  }
</div>
